import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { VehiculoZEEdit } from "./edit";
const EditModal = VehiculoZEEdit;
type Entity = models.VehiculoZE;
const resource = resources.UsuarioZE;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void>;
    readonly?: boolean;
}

/**Obtiene las columnas del grid */
function columnas(deps: kea.BotonesListaDeps<Entity>): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [
        botones,
        { title: "Marca", cell: x => ({ data: x.Marca }) },
        { title: "Modelo año", cell: x => ({ data: x.ModeloAño }) },
        { title: "Peso", cell: x => ({ data: x.peso }) },
        { title: "Placas", cell: x => ({ data: x.Placas }) },
        { title: "VIN", cell: x => ({ data: x.VIN }) },
        { title: "Color", cell: x => ({ data: x.Color }) },
    ];
}

/**
* Listado de VehiculoZE
*/
class VehiculoZEListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();
    private handleOnAgregar = async () => {
        const result = await this.modals.showModal(EditModal, undefined, {} as Entity);;
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }

    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.Marca);
        if (ok) {
            var ccc = await resource.BorrarVehiculoZE( item );

            if (ccc.Respuesta) {
                const oldList = this.props.value;
                await this.props.onChange(oldList.filter(x => x != item));
            }
            else
            {await kea.message(ccc.Mensaje) }
        }
    }

    render() {
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar });
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            <span>Vehículos</span>
                            <div className="pull-right">
                                <kea.AgregarButton onClick={this.handleOnAgregar} disabled={this.props.readonly} />
                            </div>
                        </h4>
                    </div>
                </div>

                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const VehiculoZEList = kea.mapProps(componentToRx(VehiculoZEListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuariosze/edit/componentes/vehiculos/list.tsx